import $ from "jquery";
import tagsinput from 'bootstrap-tagsinput';

if (window.CKEDITOR) {
    CKEDITOR.disableAutoInline = true;
    CKEDITOR.config.extraPlugins = 'iframe,autogrow';
}
$(document).ready(function () {
    if (window.CKEDITOR) {
        $.each($('.htmlEditor'), function () {
            var me = $(this);
            me.not('[contenteditable]').ckeditor({
                contentsCss: '/files/dist/ckeditor.css',
                bodyClass: me.attr('data-ckbody-class'),
            });
        });
        $.fn.selectpicker.Constructor.BootstrapVersion = '4';
    }

    $('form .submit').click(function () {
        $(this).parents('form').submit();
        return false;
    });
    $(document).on('click.bs.dropdown.data-api', '.keep-open', function (ev) {
        ev.stopPropagation();
    });
});

$(document).on('content-ready', function (ev, container) {
    $.each(container.find('[data-mask]'), function (ev) {
        var me = $(this);
        me.inputmask({
            mask: me.attr('data-mask'),
            clearMaskOnLostFocus: me.attr('data-clearmaskonlostfocus') === "true",
        });
    });

    container.find('.dropdown-menu [data-dropdown-close]').click(function (ev) {
        $(ev.currentTarget).closest('.dropdown-menu').removeClass('show');
    });

    container.find('.dropdown,[data-toggle="dropdown"]').on('hide.bs.dropdown', function (ev) {
        if (ev.clickEvent) {
            var clickTarget = $(ev.clickEvent.target);
            if (clickTarget.is('.keep-open') || clickTarget.closest('.keep-open').length >= 1) {
                ev.preventDefault();
            }
        }
    });

    $.each(container.find('[data-bs-auto-close]'), function (ev) {
        var me = $(this);
        var dropdown = me.parent();
        dropdown.on('hide.bs.dropdown', (ev) => {
            if (me.attr('data-bs-auto-close') === 'outside' && ev.clickEvent) {
                var isClickInside = $(ev.clickEvent.target).is('.dropdown-menu') || $(ev.clickEvent.target).closest('.dropdown-menu').length === 1;
                if (isClickInside) {
                    ev.preventDefault();
                    return false;
                }
            }
            if (me.attr('data-bs-auto-close') === 'manual') {
                ev.preventDefault();
                return false;
            }
        });
    });

    container.find('.dropdown-textinput .dropdown-item').on('click', function (ev) {
        var me = $(this);
        var container = me.closest('.dropdown-textinput');
        container.find('input').val(me.html());
    });

    container.find('.select-dropdown .dropdown-item').on('click', function (ev) {
        var me = $(this);
        me.closest('.dropdown-menu').find('.active').removeClass('active');
        me.addClass('active');
        var dropdown = me.closest('.select-dropdown');
        if (dropdown.is('[data-control-name]')) {
            $('[name="' + dropdown.attr('data-control-name') + '"]').val(me.attr('data-value') || me.html());
        }
    });
    container.find('.select-dropdown').on('hide.bs.dropdown', function (ev) {
        var me = $(this);
        var selected = me.find('.active').not('.inactive');
        $(ev.relatedTarget).html(selected.attr('data-display') || selected.html());
    });
    container.find('.select-dropdown[data-list]').on('show.bs.dropdown', function (ev) {
        var me = $(this);
        var meMenu = me.find('.dropdown-menu');
        // Add items if not there
        if (meMenu.find('.dropdown-item').length === 0) {
            var menu = $(me.attr('data-list'));
            menu.find('.dropdown-item').clone().appendTo(meMenu);
            me.find('.dropdown-item').on('click', function (ev) {
                $(this).closest('.dropdown-menu').find('.active').removeClass('active');
                $(this).addClass('active');
                me.attr('data-selected', $(this).attr('data-value'));
            });
        }
        if (me.is('[data-selected]')) {
            meMenu.find('[data-value="' + me.attr('data-selected') + '"]').addClass('active');
        }
        meMenu.data('this', meMenu);
    });
    container.find('.select-dropdown[data-list]').on('shown.bs.dropdown', function (ev) {
        var me = $(this);
        if (me.is('[data-filterable]')) {
            var meMenu = me.find('.dropdown-menu');
            var filterEl = me.find('[data-filter]');
            var items = meMenu.find('[data-search]');
            filterEl.val("");
            filterEl.keyup(function () {
                var query = filterEl.val().toLowerCase();
                $.each(items, function () {
                    var item = $(this);
                    if (item.attr('data-search').indexOf(query) === -1) {
                        item.removeClass('d-flex').addClass('d-none');
                    } else {
                        item.removeClass('d-none').addClass('d-flex');
                    }
                });
            });
            meMenu.width(meMenu.width());

            var $scrollTo = meMenu.find('.active');
            meMenu.scrollTop(
                $scrollTo.offset().top - meMenu.offset().top + meMenu.scrollTop() - (meMenu.height() / 2)
            );

            filterEl.focus();
        }
    });

    container.find('.dropdown-select').each(function () {
        var el = $(this);
        initDropdownSelectItems(el);
    });

    $.each(container.find('.control-tagsinput'), function () {
        var tagEls = $(this);

        tagEls.tagsinput({
            freeInput: (tagEls.attr('data-freeInput') ? tagEls.attr('data-freeInput') === 'true' : true),
            allowDuplicates: false,
            placeholderText: '...',
            tagClass: 'badge badge-primary',
            typeahead: {
                source: function (query) {
                    return $.getJSON(tagEls.attr('data-source'), { query: query });
                },
                item: '<li class="dropdown-item"><a href="#"></a></li>',
            },
            itemValue: function (item) {
                return (item.id + "|" + item.name).replace(/"/g, '&quot').replace(/"/g, '\"');
            },
            itemText: function (item) {
                return item.name;
            },
        });
        var inputEl = tagEls.parent().find('.bootstrap-tagsinput input');
        inputEl.change(function() {
            $(this).val('');
        });

        var tagsVal = [];
        if (tagEls.val()) {
            tagsVal = (tagEls.val() || '').split(",");
        }
        if (tagEls.is('[data-tags]')) {
            var tagsValContent = ($(tagEls.attr('data-tags')).html().trim() || '');
            if (tagsValContent !== "") {
                tagsVal = tagsValContent.split(",");
            }
        }
        $.each(tagsVal, function (i, item) {
            var values = item.split("|");
            if (tagsValContent !== "") {
                tagEls.tagsinput('add', {id: values[0], name: values[1]});
            }
        });
    });

    // container.find('.form-colorpicker').each(function () {
    //     var el = $(this);
    //     el.colorpicker();
    // });

    container.find('[data-plzsync]').blur(function () {
        var plzInput = $(this);
        var targetField = $(plzInput.attr('data-plzsync'));
        searchPlzInfo(plzInput, targetField);
    });

    container.find('.googlemap-display').each(function () {
        var gmap = $(this);
        if (gmap.length == 1 && typeof google != 'undefined') {
            var myPosition = new google.maps.LatLng(parseFloat(gmap.attr('data-lat')), parseFloat(gmap.attr('data-lng')));
            var mapOptions = {
                scrollwheel: false,
                zoom: parseInt(gmap.attr('data-zoom') || 12),
                center: myPosition,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: window.mapStyle,
            };
            var map = new google.maps.Map(gmap[0], mapOptions);
            var marker = new google.maps.Marker({
                position: myPosition,
                map: map,
                draggable: false
            });
        }
    });

    // Input help-texts
    container.find('.input-group[data-helptarget]').each(function () {
        var me = $(this);
        var targetEl = $(me.attr('data-helptarget'));
        me.find('input').focus(function () {
            targetEl.collapse('show');
        });
        me.find('input').blur(function () {
            targetEl.collapse('hide');
        });
    });

    if ($.fn.ionRangeSlider) {
        container.find(".ion-range").ionRangeSlider({
            onFinish: function (data) {
                $(data.input).trigger("onChanged", [data]);
            },
            onChange: function (data) {
                $(data.input).trigger("onChange", [data]);
            }
        });
    }
    // if (window.dropzone) {
    //     dropzone.init(container, {});
    // }
    registerDragables(container);
    registerSortables(container);
    registerDatePickers(container.find('.ctl-datepicker'));
    initSlideinButtons(container.find('[data-slidein],[data-static-slidein]'));
    initCheckboxes(container.find('input[type=checkbox][data-action]'));
    initCheckboxAllOnOff($('body'));
    initExpanders(container.find('.expandable'));
    initBootstrapSelect(container.find('.selectpicker'));
});

function initDropdownSelectItems(dropdownSelectEl) {
    var inputEl = dropdownSelectEl.find('input');
    var displayEl = dropdownSelectEl.find('input.form-display');
    dropdownSelectEl.find('.dropdown-item').not('.disabled').click(function () {
        dropdownSelectEl.find('.dropdown-item.bg-light').removeClass('bg-light');
        $(this).addClass('bg-light');
        inputEl.val($(this).attr('data-value') || $(this).text());
        inputEl.trigger('changed');
        if (displayEl.length) {
            displayEl.val($(this).attr('data-display'));
        }
    });
    inputEl.keyup(ev => {
        var query = inputEl.val().toLowerCase();
        $.each(dropdownSelectEl.find('.dropdown-item[data-search]'), (i, itemEl) => {
            var item = $(itemEl);
            if (item.attr('data-search').indexOf(query) === -1) {
                item.removeClass('d-flex').addClass('d-none');
            } else {
                item.removeClass('d-none').addClass('d-flex');
            }
        });
    });
}
window.initDropdownSelectItems = initDropdownSelectItems;

function searchPlzInfo(plzField, targetField, onComplete) {
    var plz = plzField.val();
    if (plz.length === 4) {
        targetField.inputRunning();
        var apiHref = 'https://api3.geo.admin.ch/rest/services/api/MapServer/find?layer=ch.swisstopo-vd.ortschaftenverzeichnis_plz&searchText=' + plz + '&searchField=plz&limit=1&returnGeometry=false';
        connection.getJson(apiHref, {
            onComplete: function () {
                targetField.inputEndRunning();
            },
            onSuccess: function (data) {
                if (data.results.length > 0) {
                    var attrs = data.results["0"].attributes;
                    targetField.val(attrs.langtext).trigger('change');
                    if (plzField.is('[data-kantonsync]')) {
                        $(plzField.attr('data-kantonsync')).val(attrs.gdekt);
                    }
                    if (plzField.is('[data-landsync]')) {
                        $(plzField.attr('data-landsync')).val('Schweiz');
                    }
                    if (onComplete) onComplete(attrs);
                }
            },
            onError: function () {
                // prevent error message
            },
        });
    }
}
window.searchPlzInfo = searchPlzInfo;

function registerSortables(container) {

}

function registerDragables(container) {
    $.each(container.find('[data-dragsort]'), function () {
        var sortContainer = $(this);
        var itemsSelector = sortContainer.attr('data-dragsort-items') || "> .sort-item";
        sortContainer.sortable({
            helper: "clone",
            handle: sortContainer.attr('data-dragsort-handle') || ".sort-handle",
            items: itemsSelector,
            axis: "y",
            start: function(e, ui) {
                console.log(e, ui);
            },
            stop: function (e, ui) {
                var droppable = $(this);
                if (droppable.attr('data-sort-ajax')) {
                    var params = {
                        id: $(ui.item).attr('data-sort-id'),
                    };
                    droppable.startProcess();
                    var itemsContainer = sortContainer;
                    if (sortContainer.attr('data-sort-containers')) {
                        itemsContainer = $(ui.item).closest(sortContainer.attr('data-sort-containers'));
                    }
                    if (itemsContainer.attr('data-sort-params')) {
                        try {
                            params = $.extend(params, JSON.parse(itemsContainer.attr('data-sort-params').replace(/'/g, '\"')));
                        } catch (e) {
                        }
                    }

                    params.sortList = {};
                    var siblings = itemsContainer.find(itemsSelector);
                    $.each(siblings, function (i, el) {
                        params.sortList[$(el).attr('data-sort-id')] = i;
                    });

                    // $.each(itemsContainer.find(sortContainer.attr('data-dragsort-items') || '.sort-item'), function (i, el) {
                    //     try {
                    //         params.items.push(JSON.parse($(el).attr('data-sort-params').replace(/'/g, '\"')));
                    //     } catch (e) {
                    //     }
                    // });
                    connection.getJson(droppable.attr('data-sort-ajax'), {
                        data: params,
                        onSuccess: function () {
                            messaging.showGlobalMessage('success', null, 'Die Sortierung wurde geändert');
                        },
                        onComplete: function () {
                            droppable.endProcess();
                        },
                        onError: function () {
                            debugger;
                        }
                    });
                }
            },
        });
    });

    $.each(container.find('[data-dragdrop]'), function () {
        var me = $(this);

        var helper = "clone";
        if (me.attr('data-drag-info')) {
            helper = function () {
                return '<div class="bg-light p-1">' + me.attr('data-drag-info') + '</div>';
            }
        }
        var handlerSelector = me.attr('data-drag-handlers') || '.drag-handle';
        me.sortable({
            items: 'tr.leaf',
            handle: handlerSelector,
            helper: helper,
            axis: "y",
            stop: function (e, ui) {
                var itemEl = $(ui.item);
                var previousTreeNode = itemEl.prevAll(`.node[data-depth="${itemEl.attr('data-depth') - 1}"]`).first();
                console.log(previousTreeNode, itemEl);
                if (previousTreeNode.attr('data-id') == itemEl.attr('data-tt-parent-id')) {
                    console.log(e, ui);
                    var sortList = {};
                    var siblings = project.container.find(`[data-tt-parent-id="${itemEl.attr('data-tt-parent-id')}"]`);
                    $.each(siblings, function (i, el) {
                        sortList[$(el).attr('data-id')] = i;
                    });
                    connection.getJson("/ProjectTree/MovePosition", {
                        data: {
                            id: itemEl.attr('data-id'),
                            sortList: sortList,
                        },
                        onComplete: function () {
                        }
                    });
                    return true;
                }
                return false;
            },
        });

        // var helper = "clone";
        // if (me.attr('data-drag-info')) {
        //     helper = function () {
        //         return '<div class="bg-light p-1">' + me.attr('data-drag-info') + '</div>';
        //     }
        // }
        // var handlerSelector = me.attr('data-drag-handlers') || '.drag-handle';
        // container.find(handlerSelector).draggable({
        //     helper: helper,
        //     refreshPositions: true,
        //     revert: "invalid",
        //     appendTo: $('body'),
        //     drag: function(event, ui) {
        //         console.log(event, ui, window.lastDragEl);
        //     },
        // });
        // container.find(me.attr('data-drop-targets')).droppable({
        //     accept: ".drag-handle",
        //     hoverClass: "accept",
        //     over: function (event, ui) {
        //         var toEl = $(this).closest('[data-drop-target]');
        //         window.lastDragEl = toEl;
        //         $(this).addClass('drag-over');
        //     },
        //     out: function (event, ui) {
        //         $(this).removeClass('drag-over');
        //     },
        //     drop: function (event, ui) {
        //         var droppable = $(this);
        //         droppable.removeClass('drag-over');
        //         if (droppable.attr('data-drop-ajax')) {
        //             var params = {};
        //             droppable.startProcess();
        //             var dragElement = ui.draggable.is('[data-drop-params]') ? ui.draggable : ui.draggable.closest('[data-drop-params]');
        //             try {
        //                 params = JSON.parse(dragElement.attr('data-drop-params').replace(/'/g, '\"'));
        //             } catch (e) {
        //             }
        //             var sortList = {};
        //             var siblings = droppable.find(`[data-calculation]`);
        //             $.each(siblings, function (i, el) {
        //                 sortList[$(el).attr('data-calculation')] = i;
        //             });
        //             params["sortList"] = sortList;
        //
        //             connection.getJson(droppable.attr('data-drop-ajax'), {
        //                 data: params,
        //                 onSuccess: function () {
        //                     droppable.prepend(dragElement);
        //                     messaging.showGlobalMessage('success', null, 'Das Objekt wurde verschoben.');
        //                 },
        //                 onComplete: function () {
        //                     droppable.endProcess();
        //                 },
        //                 onError: function () {
        //                     debugger;
        //                 }
        //             });
        //         }
        //     }
        // });
    });
}

function registerDatePickerCbo(container) {
    var pickers = container.find('[data-dp-container]');
    $.each(pickers, function (index, el) {
        var container = $(el);
        var ctlDay = container.find('[data-dp-cbo="day"]');
        var ctlMonth = container.find('[data-dp-cbo="month"]');
        var ctlYear = container.find('[data-dp-cbo="year"]');

        ctlMonth.selectpicker({
            liveSearch: true,
            liveSearchPlaceholder: 'Monat'
        });
        ctlDay.selectpicker({
            width: 80,
            liveSearch: true,
            liveSearchPlaceholder: 'Tag'
        });
        ctlYear.selectpicker({
            liveSearch: true,
            liveSearchPlaceholder: 'Jahr'
        });

        var target = container.find('input');
        container.find('[data-dp-cbo]').change(function () {
            var dateValue = moment(ctlYear.val() + "-" + ctlMonth.val() + "-" + ctlDay.val());
            if (dateValue.format('YYYY-MM-DD') !== "Invalid Date") {
                target.val(dateValue.format('YYYY-MM-DD'));
            } else {
                target.val('');
            }
        });

        ctlDay.on('shown.bs.select', function (e, clickedIndex, isSelected, previousValue) {
            var dayMenu = ctlDay.parent().find('ul.dropdown-menu');
            var dateValue = moment(ctlYear.val() + "-" + ctlMonth.val() + "-01");
            var daysInMonth = dateValue.daysInMonth();
            dayMenu.find('li').show();
            dayMenu.find('li').filter(function (i, el) {
                return (i + 1) > daysInMonth;
            }).hide();
            if (dayMenu.find('li.selected').is(':hidden')) {
                $(ctlDay).selectpicker('val', '1');
            }
        });

        ctlMonth.change(function () {
            var dateValue = moment(ctlYear.val() + "-" + ctlMonth.val() + "-01");
            var daysInMonth = dateValue.daysInMonth();
            if (parseInt(ctlDay.val()) > daysInMonth) {
                $(ctlDay).selectpicker('val', daysInMonth);
            }
        }).change();
    });
}
window.registerDatePickerCbo = registerDatePickerCbo;

function registerDatePickers(pickers, options) {
    if (!pickers.datepicker) {
        alert("datepicker not available!");
        return;
    }

    $.each(pickers, function (i, el) {
        var valueInputEl = $(el);
        if (valueInputEl.parent().is('.datepicker-container')) return;

        valueInputEl.wrap('<div class="input-group datepicker-container dropdown"></div>');
        var container = valueInputEl.parent();
        var displayInputEl = valueInputEl.clone();
        displayInputEl.attr('id', displayInputEl.attr('id') + 'display' + Math.ceil(Math.random() * 200))
            .attr('name', '');
        valueInputEl.addClass('d-none').after(displayInputEl);
        $(`<div class="input-group-append dropdown-toggle no-arrow linkify" data--target="#jobDropdownMenu" data-toggle="dropdown">
               <span class="input-group-text bg-lightgray"><i class="fa bi-calendar"></i></span>
               <div class="dropdown-menu dropdown-menu-end">
                   <div class="p-10 inline-picker"></div>
               </div>
           </div>`)
            .insertAfter(displayInputEl);
        if (valueInputEl.val()) {
            var startValue = moment(valueInputEl.val());
            displayInputEl.val(startValue.format('DD.MM.YYYY'));
        }
        displayInputEl.inputmask({
            alias: "datetime",
            inputFormat: 'dd.mm.yyyy',
            clearMaskOnLostFocus: false,
        });

        var pickerEl = container.find('.inline-picker');
        var pickerOptions = $.extend({
            language: 'de',
            format: 'dd.mm.yyyy',
            autoclose: true,
            todayHighlight: true,
        }, options || {});
        pickerEl.datepicker(pickerOptions);
        pickerEl.on('changeDate', function (ev) {
            var me = $(this);
            var picker = me.data('datepicker');
            if (picker.dates.length > 0) {
                var date = dayjs(picker.dates.get());
                var oldDate = displayInputEl.attr('data-val');
                if (oldDate !== date.format("DD.MM.YYYY")) {
                    displayInputEl.val(date.format("DD.MM.YYYY"));
                }
                valueInputEl.val(date.format("YYYY-MM-DD"));
            } else {
                displayInputEl.val('');
                valueInputEl.val('');
            }
            container.removeClass('is-invalid');
            valueInputEl.trigger('change', {ev: ev});
            // container.find('.dropdown-toggle').dropdown('hide');
        });
        pickerEl.on("changeMonth", function (e) {
            pickerEl.find('tbody').off('click').on('click', 'tr > .day', function (ev) {
                container.find('.dropdown-toggle').dropdown('hide');
            })
        });
        pickerEl.on('clearDate', function (ev) {
            displayInputEl.val('');
            valueInputEl.val('');
            container.removeClass('is-invalid');
        });

        var date = dayjs(valueInputEl.val());
        if (date.isValid()) {
            pickerEl.datepicker("setDate", date.toDate());
        }
        displayInputEl.on('focus', ev => {
            container.find('.dropdown-toggle').dropdown('show');
            var inputDate = displayInputEl.val();
            displayInputEl.attr('data-val', inputDate);

            pickerEl.trigger('changeMonth');
            // hide all other datepickers
            $.each($('.datepicker-container').not(container), (i, el) => {
                $(el).find('.dropdown-toggle').dropdown('hide');
            });
        });
        displayInputEl.on('keyup', ev => {
            var inputDate = displayInputEl.val();
            var day = parseInt(inputDate.substr(0, 2));
            var month = parseInt(inputDate.substr(3, 2));
            var year = parseInt(inputDate.substr(6, 4));
            if (isNaN(day) || isNaN(month) || isNaN(year)) return;

            var date = dayjs(`${year}-${month}-${day}`);
            if (date.isValid()) {
                displayInputEl.attr('data-val', inputDate);
                pickerEl.datepicker("setDate", date.toDate());
                container.removeClass('is-invalid');
            }
        });
        container.on('focusout', ev => {
            var oldDate = displayInputEl.attr('data-val');
            var inputDate = displayInputEl.val();
            if (inputDate === oldDate) return;

            if (inputDate !== '') {
                var date = dayjs(`${inputDate.substr(6, 4)}-${inputDate.substr(3, 2)}-${inputDate.substr(0, 2)}`);
                if (date.isValid()) {
                    pickerEl.datepicker("setDate", date.toDate());
                    container.removeClass('is-invalid');
                } else {
                    container.addClass('is-invalid');
                }
            } else {
                displayInputEl.val('');
                valueInputEl.val('');
                container.removeClass('is-invalid');
            }
        });
    });

    // $.each(pickers, function (index, el) {
    //     var field = $(el);
    //     if (field.parent().is('.datepicker-container')) return;
    //     //
    //     field.wrap('<div class="input-group datepicker-container"></div>');
    //     var displayEl = field.clone();
    //     displayEl.attr('id', displayEl.attr('id') + 'display' + Math.ceil(Math.random() * 200))
    //         .attr('name', '');
    //     field.addClass('d-none').after(displayEl);
    //     $('<div class="input-group-append linkify"><span class="input-group-text bg-lightgray"><i class="fa bi-calendar"></i></span></div>').insertAfter(displayEl);
    //     if (field.val()) {
    //         var startValue = moment(field.val());
    //         displayEl.val(startValue.format('DD.MM.YYYY'));
    //     }
    //     field.parent().find('.input-group-append').click(function () {
    //         debugger;
    //         displayEl.datepicker('show');
    //     });
    //     displayEl.datepicker({
    //         language: 'de',
    //         format: 'dd.mm.yyyy',
    //         todayHighlight: true,
    //         firstDay: 1,
    //         autoclose: true,
    //     }).on('changeDate, hide', function (e) {
    //         field.val(e.format('yyyy-mm-dd'))
    //             .trigger('blur', {ev: e})
    //             .trigger('change', {ev: e});
    //     });
    // });
}
window.registerDatePickers = registerDatePickers;

function initSlideinButtons(elements) {
    elements.off('click').click(function (ev) {
        var me = $(this);
        if (me.is('[data-slidein]')) {
            slidein.openUrl(me.attr('data-slidein'), function (element) {
            }, {
                linkEl: me,
                timeout: me.attr('data-timeout'),
                overlay: me.is('[data-overlay]'),
                backbutton: me.attr('data-back'),
            });
        } else if (me.is('[data-static-slidein]')) {
            slidein.openUrl('', function () {
            }, {
                contentElement: $(me.attr('data-static-slidein')),
            });
        }
        if (me.is('[data-return]')) {
            return me.attr('data-return') === "true";
        }
        return false;
    });
}
window.initSlideinButtons = initSlideinButtons;

function initExpanders(elements) {
    $.each(elements, function () {
        var me = $(this);
        var area = me.find('.expander');
        if (area.find('>').height() > me.height()) {
            me.addClass('isbigger');
            me.find('>i').off('click').on('click', function () {
                var height = area.find('>').height();
                if (me.hasClass('opened')) {
                    area.animate({
                        height: area.data('height')
                    });
                    me.removeClass('opened');
                } else {
                    area.animate({
                        height: height
                    });
                    me.addClass('opened');
                }
            });
        }
    });
}
window.initExpanders = initExpanders;

function initBootstrapSelect(elements) {
    $.each(elements, function () {
        var me = $(this);
        me.selectpicker({
            liveSearchPlaceholder: 'filtern ...'
        });
    });
}
window.initBootstrapSelect = initBootstrapSelect;

function initCheckboxes(elements, options) {
    options = options || {};
    var attribute = options.attribute || 'data-action';
    elements.click(function () {
        var me = $(this);
        if (!me.is('[' + attribute + ']')) return;

        var task = {
            run: function (onComplete, onTaskError) {
                $.ajax({
                    url: me.attr(attribute),
                    type: 'get',
                    dataType: 'json',
                    timeout: connection.defaultTimeout,
                    data: {
                        add: me.is(':checked')
                    },
                    success: function (data) {
                        if (data.checked == true) {
                            messaging.showGlobalMessage('success', null, 'Die Änderung wurde gespeichert.');
                        } else if (data.checked == false) {
                            messaging.showGlobalMessage('success', null, 'Die Änderung wurde gespeichert.');
                        } else {
                            messaging.showPermanentGlobalMessage('danger', null, 'Fehler beim speichern!');
                        }
                        if (options.onSuccess != null) options.onSuccess(data, me);
                        $(me).trigger('checkbox.changed', {target: me, checked: data.checked});
                    },
                    error: function (data) {
                        if (data.responseJSON && data.responseJSON.checked) {
                            me.prop('checked', data.responseJSON.checked ? 'checked' : null);
                        }
                        if (data.statusText == 'timeout' && onTaskError) {
                            onTaskError(null, true);
                            return;
                        }
                        if (onTaskError) onTaskError(connection.getErrorMessageOf(data, 'Speichern fehlgeschlagen'), false, function () {
                            if (options.onError) {
                                options.onError(data.responseJSON, data);
                            }
                        });
                    },
                    complete: function () {
                        if (onComplete != null) onComplete();
                    }
                });
            }
        };
        taskQueue.add(task);
    });
}
window.initCheckboxes = initCheckboxes;

function initCheckboxAllOnOff(container) {
    container.find('[data-allon]').click(function () {
        var me = $(this);
        $.each(container.find('.' + me.attr('data-allon') + ' .form-check-label input'), function (i, el) {
            if (!$(el).is(':checked')) {
                $(el).trigger('click');
            }
        });
    });
    container.find('[data-alloff]').click(function () {
        var me = $(this);
        $.each(container.find('.' + me.attr('data-alloff') + ' .form-check-label input'), function (i, el) {
            if ($(el).is(':checked')) {
                $(el).trigger('click');
            }
        });
    });
}
window.initCheckboxAllOnOff = initCheckboxAllOnOff;
